import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import userReducer from "./Slices/userSlice";
import userProfileReducer from "./Slices/userProfile";
import referalReducer from "./Slices/referalMainAcc";
import infoReducer from "./Slices/infoModal";
import sliderReducer from "./Slices/sliderSlice";
import languageReducer from "./Slices/languageSlice";
import translationDataReducer from "./Slices/translationDataSlice";
const rootReducer = combineReducers({
  user: userReducer,
  userProfile: userProfileReducer,
  referal: referalReducer,
  info: infoReducer,
  slider: sliderReducer,
  language: languageReducer,
  translationData: translationDataReducer,
});
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["referal"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
